import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { IState, EmptyState } from "./State";
import { useForm } from 'react-hook-form';
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { useEffect, useState } from "react";
import { Fetch } from "../../../shared/Fetch";
import { JVInput } from "../../../shared/JVInput";
import { ICountryMastDropdown } from "../../../models/IDropdown";
import { JVDropdownInput } from "../../../shared/JVDropdownInput";

const schema = yup.object({
    country: yup.object().shape({
        country_ID: yup.number().min(1, "Country is required*").required("Country is required*"),
        country_Name: yup.string().required()
    }),
    state_Name: yup.string().required("State Name is required*"),
    description: yup.string().nullable()
});

interface Iprops {
    singleData: IState,
    open: boolean,
    hideDialog: () => void,
    toast: any,
    reload: boolean,
    setReload: (is: boolean) => void
}

export const Form = (props: Iprops) => {
    const [countries, setCountries] = useState<Array<ICountryMastDropdown>>();

    const { control, handleSubmit, formState: { errors }, reset } = useForm<IState>({
        resolver: yupResolver(schema),
        defaultValues: props.singleData,
        shouldFocusError: false
    });

    useEffect(() => {
        reset(props.singleData);
    }, [props.singleData]);

    const loadCountries = async (filter: string | null) => {
        const response = await Fetch("Dropdown/countries", "GET", null, `filter=${filter}`, null);
        if (response) {
            const data: Array<ICountryMastDropdown> = await response.json();
            setCountries(data);
        }
    }
    const completeMethodCountries = (event: { query: string }) => {
        loadCountries(event.query);
    }

    const saveToDB = async (body: IState) => {
        const method = props.singleData.state_ID ? "PUT" : "POST";
        const message = props.singleData.state_ID ? "Updated Successfully" : "Added Successfully";

        body.country_ID = body.country?.country_ID;
        delete body.country;

        const response = await Fetch("State_Mast", method, body, null, props.toast);

        if (response) {
            props.hideDialog();
            props.toast.current.show({ severity: 'success', detail: message, life: 3000 });
            props.setReload(!props.reload);
        }
    }

    const onHide = () => {
        props.hideDialog();
        reset(EmptyState);
    }

    function onSubmit(data: IState) {
        saveToDB(data);
    }

    return (
        <Dialog visible={props.open} style={{ width: '80vw' }} header="Add/Edit State" modal className="p-fluid" onHide={onHide}>
            <form onSubmit={handleSubmit(onSubmit)} className="p-fluid formgrid grid">

                <JVDropdownInput required column={2} label="Country" completeMethod={completeMethodCountries} control={control} name="country" error={errors.country?.country_ID?.message} options={countries} optionLabel="country_Name" placeholder="Search Country" />
                <JVInput required column={2} label="State Name" control={control} name="state_Name" error={errors.state_Name?.message} />
                <JVInput column={1} label="Description" control={control} name="description" error={errors.description?.message} />
                <div className="col-12 md:col-12">
                    <Button className="field col-12 md:col-6" label="SAVE" type="submit"></Button>
                    <Button className="field col-12 md:col-6 p-button-outlined" label="CLOSE" onClick={onHide} type="button"></Button>
                </div>
            </form>
        </Dialog>
    );
}
